import React, { memo } from "react";
import { HStack, Spacer } from "@chakra-ui/react";
import useMessageThreadDraft from "modules/hooks/use-message-thread-draft";
import { MessageThreadType } from "gql/graphql";
import ComposeMakePrivateToggle from "./compose-make-private-toggle";
import ComposeMakeTaskPriorityToggle from "./compose-make-task-priority-toggle";
import ComposeReadOnlyToggle from "./compose-read-only-toggle";

interface IProps {
  draftId: string;
}

const ComposeAccessControlToolbar = ({ draftId }: IProps) => {
  const { draft, isDraftLoaded } = useMessageThreadDraft({ draftId });

  if (!draft || !isDraftLoaded) return null;

  if (draft.type === MessageThreadType.Thread) {
    return (
      <HStack w="full">
        <ComposeMakePrivateToggle draftId={draftId} />
        <Spacer />
        <ComposeReadOnlyToggle draftId={draftId} />
      </HStack>
    );
  }

  if (draft.type === MessageThreadType.Task) {
    return (
      <HStack w="full">
        <ComposeMakePrivateToggle draftId={draftId} />
        <Spacer />
        <ComposeMakeTaskPriorityToggle draftId={draftId} />
      </HStack>
    );
  }

  return null;
};

export default memo(ComposeAccessControlToolbar);
